module.exports = __webpack_public_path__ + "static/media/No Lie - Instrumental Version.68b346d7.jpg";